import axios from "axios";
import { axiosNoAuth } from "../../config/axiosInstances";
import { SET_COURSE_UNLOCK_POLLING, SET_COURSE_UNLOCK_STATUS } from "./types";
export function getRelatedSubjects(subject_name, n, successCallback, errorCallback){
    return async function(dispatch) {
        try {
            const response = await axios.post('https://ninjacurate.learntube.ai/similar_skills_list', {
                subject_name,
                n
            })
            successCallback && successCallback(response?.data)
        } catch (error) {
            errorCallback && errorCallback(error)
        }   
    }
}


export function setPaymentRecord(Name , email , payment_status , amount ,product_name ,razorpay_payment_id , razorpay_order_id , expires_on, successCallback , errorCallback){
    return async function(dispatch) {
        try {
            const response = await axios.post('https://xgfy-czuw-092q.m2.xano.io/api:NGfD0xN1/process_payment', {
                Name,
                email,
                payment_status,
                amount,
                product_name,
                razorpay_payment_id,
                razorpay_order_id,
                expires_on
            })
            successCallback && successCallback(response?.data)
            
        } catch (error) {
            errorCallback && errorCallback(error)
        }
    }
}

export function getRelatedPersonalisedSkills(subject_name , successCallback , errorCallback){
    return async function(dispatch) {
        try {
            const response = await axios.get('https://ninjacurate.learntube.ai/get_available_skill_names', {
                params: {
                    subject_name
                }
            })
            successCallback && successCallback(response?.data)
        } catch (error) {
            errorCallback && errorCallback(error)
        }
    }
}


export function fetchUUID(name, email, phone_number, skill_name, medium, source, successCallback, errorCallback) {
    return async function(dispatch) {
        try {
            const response = await axios.post('https://ninjacurate.learntube.ai/mobile_app/creation_id', {
                name,
                email,
                phone_number,
                skill_name,
                medium,
                source
            })
            successCallback && successCallback(response?.data)
        } catch (error) {
            console.log(error.message)
            errorCallback && errorCallback(error)
        }
    }
}

export function curateUsersCourse(user_id, email, name, skill_name, is_bundle, bundle_courses, phone_number, is_onboarding, successCallback, errorCallback) {
    return async function(dispatch) {
        try {
            const response = await axios.post('https://ninjacurate.learntube.ai/academy_course_onboarding', { user_id, email, name, skill_name, is_bundle, bundle_courses, phone_number , is_onboarding })
            successCallback && successCallback(response?.data)
        } catch (error) {
            errorCallback && errorCallback(error)
        }
    }
}

export function getUserOlduuid(email, successCallback, errorCallback) {
    return async function(dispatch) {
        const maxAttempts = 30; // Poll for 20 attempts
        const interval = 2000; // Poll every 3 seconds
        let attempts = 0;
        let pollingTimeout = null;

        const pollUserAuthentication = async () => {
            try {
                attempts++;
                
                const response = await axios.post('https://ninjacurate.learntube.ai/user_authenticate', {
                    user_email: email,
                });

                const responseData = response?.data;

                // Check if we got a valid uid in the response
                if (responseData && responseData.uid) {
                    // Success - got the uid
                    if (pollingTimeout) {
                        clearTimeout(pollingTimeout);
                    }
                    
                    successCallback && successCallback(responseData);
                    return;
                }

                // Check if response contains error message - continue polling
                if (responseData && responseData.Error) {
                    // Continue polling if not max attempts
                    if (attempts < maxAttempts) {
                        pollingTimeout = setTimeout(pollUserAuthentication, interval);
                    } else {
                        // Max attempts reached
                        errorCallback && errorCallback(new Error('Max polling attempts reached. User authentication not ready.'));
                    }
                    return;
                }

                // Unexpected response format
                if (attempts < maxAttempts) {
                    pollingTimeout = setTimeout(pollUserAuthentication, interval);
                } else {
                    errorCallback && errorCallback(new Error('Max polling attempts reached. Unexpected response format.'));
                }

            } catch (error) {
                // Stop polling on error
                if (pollingTimeout) {
                    clearTimeout(pollingTimeout);
                }
                
                errorCallback && errorCallback(error);
            }
        };

        // Start polling
        pollUserAuthentication();
    };
}

export function checkCourseUnlocked(user_id, courseNames, successCallback, errorCallback) {
    return async function(dispatch) {
        const maxAttempts = 30; // Poll for 30 attempts
        const interval = 5000; // Poll every 5 seconds
        let attempts = 0;
        let pollingTimeout = null;

        // Set polling status to true
        dispatch({
            type: SET_COURSE_UNLOCK_POLLING,
            payload: true
        });

        const pollCourseStatus = async () => {
            try {
                attempts++;
                
                const response = await axiosNoAuth.post(
                    'https://ninjacurate.learntube.ai/check_if_course_unlocked',
                    {
                        user_id: user_id,
                        courses: courseNames,
                    }
                );

                // Check if course is unlocked
                if (response?.data?.is_course_unlocked === true) {
                    // Course unlocked - stop polling
                    if (pollingTimeout) {
                        clearTimeout(pollingTimeout);
                    }
                    
                    dispatch({
                        type: SET_COURSE_UNLOCK_POLLING,
                        payload: false
                    });
                    
                    dispatch({
                        type: SET_COURSE_UNLOCK_STATUS,
                        payload: response?.data
                    });
                    
                    successCallback && successCallback(response?.data);
                    return;
                }

                // Continue polling if not unlocked and within max attempts
                if (attempts < maxAttempts) {
                    pollingTimeout = setTimeout(pollCourseStatus, interval);
                } else {
                    // Max attempts reached
                    dispatch({
                        type: SET_COURSE_UNLOCK_POLLING,
                        payload: false
                    });
                    
                    errorCallback && errorCallback(new Error('Max polling attempts reached'));
                }
            } catch (error) {
                // Stop polling on error
                if (pollingTimeout) {
                    clearTimeout(pollingTimeout);
                }
                
                dispatch({
                    type: SET_COURSE_UNLOCK_POLLING,
                    payload: false
                });
                
                errorCallback && errorCallback(error);
            }
        };

        // Start polling
        pollCourseStatus();
    };
}